module.exports = __webpack_public_path__ + "img/coin-network.1260bd99.png";